<template>
  <div class="coutents">


    <div class="chengtiao clearfix">

      <div class="chengtiao1190">

<!--        <div class="chengtiao1190_l2"  v-if="!loginTrue">-->
<!--          <img src="../../static/imgs/tong.png" width="25" height="25">-->
<!--           <p>专属客服：<span >{{customer?customer.name:''}}</span></p>-->
<!--           <p>电话：<span >{{customer?customer.phone:''}}</span></p>-->
<!--       </div>-->
        <div class="chengtiao1190_l2"  v-if="loginTrue">
          <img src="../../static/imgs/tong.png" width="25" height="25">
          <p>登录后，享受更多专属权益!</p>
        </div>
        <div class="chengtiao1190_r" >
          <p  v-if="!loginTrue">
            当前登录用户：<font class="red" id="fontAccount">
            {{ username }}
          </font>
          </p>
          <a @click="goOut"  v-if="!loginTrue" class="chongzhi">退出</a>
          <div style="display: flex;margin-top: 5px;" v-if="loginTrue">
            <span style="font-size: 18px;color: white;margin-right: 20px;cursor: pointer;" @click="login">登录</span>
            <div STYLE="color: white;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</div>
            <span style="font-size: 18px; color: white;margin-left: 20px;cursor: pointer; " @click="register">注册</span>
          </div>
        </div>

      </div>
    </div>
    <!-- 是个轮播 -->
    <div class="banner">
      <div class="img-box"  style="height: 400px;">
       <swiper class="swiper" :options="swiperOption">
          <swiper-slide
            class="swiper-slide"
            v-for="banner in homeBannerList"
            :key="banner.id"
          >
            <img :src="banner.extendColumn1" class="swiper-lazy" />

          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>

    </div>
    <!-- 爆款单品 -->
    <div class="popularSec">
<!--      <div class="ban">-->
<!--        <div class="dv2" v-for="item,index in classInfo" :key="item.id">-->
<!--          <div class="infoDiv">-->
<!--            <p class="p1">{{ item.text }}</p>-->
<!--            <span></span>-->
<!--            <p class="p2"> </p>-->
<!--            <div class="p3" @click="jumps(item,index)">-->
<!--              <i></i>-->
<!--              <p> </p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

        <div class="baojia clearfix">
          <ul>
            <li :style="'background:url('+item.img+') no-repeat 41px 27px;'" class="over" v-for="(item,index) in classInfo" :key="item.id" @click="jumps(item,index)">
              <a href="#" @click.prevent="jumps(item,index)" >
                <h3 class="black">{{ item.text }}</h3>
                <p class="blue">{{item.info}} </p>
              </a>
            </li>


          </ul>
        </div>



    </div>

  </div>
</template>

<script>
import { removeusername } from "../../api/myAuth";
// import { mapMutations, mapState } from "vuex";
import picUrl from "../../api/picture";
import api from "../../api/index/index";
import marquee from "@/components/marquee.vue";
export default {
  inject: ["reload"],
  components: {
    marquee
  },
  data() {
    return {
      height: '585px',
      heightRight: '404px',
      // swiper 轮播参数
      swiperOption: {
          loop: true,
          autoplay: {
            delay: 5000, // 每隔3秒自动切换
          },
          pagination: {
            el: ".swiper-pagination",
            dynamicBullets: true,
          },
          lazy: {
            lazy: true,
          },
      },
      swiperOption1: {
        direction: 'vertical', // 垂直滚动
        autoplay: {
          delay: 3000, // 每隔3秒自动切换
        },
        loop: true, // 循环播放
        slidesPerView: 1, // 每次显示一个新闻项
      },

      desc: [
        {
          id: 0,
          inx: "01",
          text: "系统核价",
        },
        {
          id: 1,
          inx: "02",
          text: "在线下单",
        },
        {
          id: 2,
          inx: "03",
          text: "在线支付",
        },
        {
          id: 3,
          inx: "04",
          text: "智能生产",
        },
        {
          id: 4,
          inx: "05",
          text: "在线跟单",
        },
        {
          id: 5,
          inx: "06",
          text: "物流配送",
        },
        {
          id: 6,
          inx: "07",
          text: "产品验收",
        },
        {
          id: 7,
          inx: "08",
          text: "交付尾款",
        },
      ],
      webOrder: [],
      loginTrue: true, // 是否登录（状态管理）
      nav: [
        {
          type: "需求大厅",
          id: 0,
        },
        {
          type: "供应商",
          id: 1,
        },
        {
          type: "版型下载",
          id: 2,
        },
        {
          type: "防伪溯源",
          id: 3,
        },
        {
          type: "印刷协会",
          id: 4,
        },
        {
          type: "印刷产业园",
          id: 5,
        },
        {
          type: "供应商入驻",
          id: 6,
        },
      ],
      classInfo: [ {} ],
      bannerList: [
        {}
      ],
      homeBannerList: [],
      username: "", //用户名
      notice: [],
      noticeLength: false, // 判断公告信息是否为发布状态并推荐 的公告信息个数
      // arr: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], //测试分割数据

      //  爆款单品
      PopularItemList: [],
      picUrls: "",
      userId: "",
      userType: "",
      customer: {}
    };
  },
  computed: {
    // ...mapState(["userInfo"]),
  },
  created() {
    let obj = JSON.parse(window.sessionStorage.getItem("currentInfo"));
    let userObj = JSON.parse(window.sessionStorage.getItem("userInfo"));
    this.customer = JSON.parse(window.sessionStorage.getItem("customer"))?JSON.parse(window.sessionStorage.getItem("customer")):{};
    if (obj) {
      this.userId = obj.user_ID;
      this.userType = obj.userType;
    }
    this.picUrls = picUrl.picUrl;
    this.queryClassInfo();

    //this.getImg(this.classInfo);
    this.init(); // 获取banner图和公告
  //  this.HotMoney(); //爆款单品
    // this.getIndexOrder(); // 获取实时订单
    if (userObj) {
      this.reload();
      this.username = userObj.username;
      this.loginTrue = false;
    } else {
      this.loginTrue = true;

      return;
    }

  },


  methods: {

    // 分割数组（用于实时订单循环）
    sliceArray(arr, length) {
      let index = arr.length;
      let newArray = [];
      for (let i = 0; i < index; i += length) {
        newArray.push(arr.slice(i, i + length));
      }
      return newArray;
    },
    // ...mapMutations(["setUserInfo"]),
    // initUserInfo(data) {
    //   this.$store.commit("setUserInfo", data);
    // },
    // 跳转到公告页面
    moreNotice(ids) {
      console.log(ids);
      this.$router.push({ name: "Proclamation", params: { id: ids } });
    },
    // 退出登录
    goOut() {
      removeusername();
      window.sessionStorage.removeItem("currentInfo");
      window.sessionStorage.removeItem("userInfo");
      window.sessionStorage.removeItem("nav");
      window.sessionStorage.removeItem("info");
      window.sessionStorage.removeItem("customer");
      api.loginOut().then((res) => {
        console.log("退出成功", res);
        if (res.success) {
          this.$message.success("退出成功");
          this.loginTrue = true;
          this.reload();
          this.$router.push({ path: "/login" });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    queryClassInfo(){
      api
          .getClassInfo(this.userType)
          .then((res) => {
            console.log("banner数据", res);
            if (res.success) {
              this.classInfo = res.data;
              this.height = Number(this.classInfo.length) * 45 + "px" ;
              this.heightRight = Number(Number(this.classInfo.length) * 45  - 180)  + "px" ;
            }
          })
          .catch((error) => {
            console.error("Error", error);
          });
    },
    // 首页基本信息获取
    init() {
      // 获取banner图
      api
        .getAllData(1, 10)
        .then((res) => {
          console.log("banner数据", res);
          if (res.success) {
            this.homeBannerList = res.data.rows;
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });
      // 公告信息
      // api
      //   .getArticle(1, 10)
      //   .then((res) => {
      //     console.log("获取公告信息", res);
      //     if (res.success) {
      //       if (res.data.list.length > 0) {
      //         res.data.list.map((el) => {
      //           el.time = this.handleTime(el.createTime);
      //         });
      //         let newArr = res.data.list.filter(
      //           (el) => el.recommend === 1 && el.articleState
      //         );
      //         console.log("筛选过后的数组", newArr);
      //         this.notice = newArr.slice(0, 3); // 截取数组，只展示3条
      //         let state = res.data.list.some(
      //           (el) => el.articleState === 1 && el.recommend === 1
      //         );
      //         if (state) {
      //           this.noticeLength = true;
      //         } else {
      //           this.noticeLength = false;
      //         }
      //         // console.log("处理后的数据", this.notice);
      //         // console.log("是否同时满足状态为发布和推荐", state);
      //       }
      //     }
      //   })
      //   .catch((error) => {
      //     console.error("Error", error);
      //   });
    },
    // 获取网站订单列表
    getIndexOrder() {
      api
        .getOrder(20, 1)
        .then((res) => {
          console.log("获取首页网站实时订单", res);
          if (res.success) {
            this.webOrder = this.sliceArray(res.data.list, 4);
          } else {
            this.$message.error("获取实时订单失败");
          }
        })
        .catch((error) => {
          console.error("Error", error);
        });
    },
    // 处理公告时间
    handleTime(time) {
      let times = time.substr(0, 10);
      let arr = times.split("-");
      return arr;
    },
    //爆款单品
    HotMoney() {
      this.$http.get("/home/getTopThreeProduct").then((res) => {
        console.log("爆款单品", res.data);
        if (res.data.code == 200) {
          this.PopularItemList = res.data.data;
        }
      });
    },
    // 登录跳转
    login() {
      this.$router.push({ path: "login" });
    },
    // 注册跳转
    register() {
      this.$router.push({ path: "register" });
    },
    // 递归动态加载本地图片
    getImg(arr) {
      console.log(arr);
      arr.forEach((el) => {
        console.log(el);
        el.img = require(`@/static/imgs/${el.img}`);
        let newArr = el.children;
        if (newArr) {
          this.getImg(newArr);
        } else {
          return;
        }
      });
    },
    // 印刷报价跳转
    jumps(item,index) {
      console.log(item);
      if (this.userId === "") {
        // this.$message.error("请先进行登录");
        this.$router.push({ path: "/login" });
      } else {
        var box = item.children[0];
        window.localStorage.setItem('_ID_', box.id) // 小类的id
        window.localStorage.setItem('_PID_', box.productId) // 小类的产品id
        window.localStorage.setItem('_radioBoxList_', JSON.stringify(item.children)) // 小类集合
        window.localStorage.setItem('_index_', index) // 大类的定位
        window.localStorage.setItem('_content_', box.content) // 大类的定位
        window.localStorage.setItem('_pgoodsName_', item.text) //大类的名称
        window.localStorage.setItem('_selectedPrintNumIndex_', 0) //
        this.reload();
 `      window.sessionStorage.setItem("nav", '1');
        this.$store.dispatch("setNavBgd", 1);`
        this.$router.push({ name: "Quotation", params: { productId: box.productId,id: box.id,goodsName:box.text,pgoodsName:item.text } });
      }
    },

  },
};
</script>

<style lang="scss" scoped>
.coutents {
  width: 100%;

  .chengtiao {
    background: #058af2;
    width: 100%;
    height: 38px;
    border-bottom: 3px solid #058af2;
  }
  .chengtiao1190 {
    width: 1200px;
    margin: 0 auto;
  }
  .chengtiao1190_l2 {
    float: left;
    display: inline;
    font-family: "微软雅黑";
    margin-left: 15px;
  }
  div {
    margin: 0 auto;
  }
  .chengtiao1190_l2 img {
    float: left;
    display: inline;
    margin-left: 7px;
    margin-top: 7px;
    cursor: pointer;
  }

  img {
    vertical-align: middle;
  }
  img {
    border: 0px;
    margin: 0px;
    padding: 0px;
    vertical-align: top;
  }
  .chengtiao1190_l2 p {
    font-size: 13px;
    float: left;
    display: inline;
    line-height: 40px;
    color: white;
    margin-left: 20px;
  }

  .chengtiao1190_r {
    float: right;
    overflow: hidden;
    text-align: center;
  }
  .chengtiao1190_r p {
    font-size: 14px;
    color: white;
    float: left;
    line-height: 40px;
    font-family: "微软雅黑";
    font-weight: bold;
  }
  .chongzhi{ width:54px; height:29px; line-height:29px; color:#fff; float:right; background:#007aff; border-radius:4px; margin-left:15px; margin-top:4px; cursor:pointer; font-family:"微软雅黑"; }

  .chongzhi:hover{ color:#fff; text-decoration:none; background:#8be231;}

  .nav {
    width: 80%;
    margin: 0 auto;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    .type {
      cursor: pointer;
      width: 15%;
      height: 50px;
      background-color: #0289f2;
      color: #fff;
      line-height: 50px;
      font-size: 18px;
      text-align: center;
      i {
        font-size: 20px;
        margin-right: 10px;
      }
    }
    .notice{
      padding: 16/75rem 28/75rem;
      font-size:24/75rem;
      color:#929292;
      line-height:38/75rem;
      display: flex;
      align-items: center;
      .icon-notice {
        width: 25/75rem;
        height: 21/75rem;
        margin-right: 14/75rem;
      }
    }

    .news-item {
      white-space: nowrap; /* 防止文字换行 */
      overflow: hidden; /* 隐藏溢出的文字 */
      text-overflow: ellipsis; /* 文字溢出时显示省略号 */
      height: 30px; /* 每个新闻项的高度 */
      display: flex;
      align-items: center;
      justify-content: center;
      list-style: none; /* 去掉默认的列表样式 */
    }
    .nav-item {
      padding: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      color: #808080;
    }
    .nav-item:hover {
      color: #0289f2;
      cursor: pointer;
    }
  }
  .banner {
    position: relative;
    width: 100%;
    .img-box {
      width: 100%;
      .swiper {
        width: 100%;
        height: 100%;
        .swiper-slide {
          width: 100%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .ification {
    width: 100%;
    // height: 420px;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    .content {
      display: flex;
      justify-content: space-between;
      width: 80%;
      // height: 100%;
      margin: 0 auto;
      .cont-left {
        width: 15%;
        // height: 100%;
        background-color: #f4f4f4;
        position: relative;
        .cont-item {
          //width: 220px;
          height: 45px;
          // display: flex;
          // align-items: center;
          .item-left {
            float: left;
            margin-top: 10px;
            img {
              width: 18px;
              height: 18px;
              margin: 0 10px 10px 10px;
            }
          }
          .item-right {
            padding-top: 10px;
            .right1 {
              font-size: 14px;
            }
            .right2 {
              font-size: 12px;
              color: #8f8f8f;
              margin-top: 5px;
            }
          }
          .infoBox {
            display: none;
            position: absolute;
            left: 100%;
            top: 1px;
            width: 480px;
            background-color: #ffffff;
            .item-info {
              box-sizing: border-box;
              padding: 15px;
              height: 100%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              align-content: flex-start;
              .info-item {
                width: 42%;
                //height: 60px;
                //display: flex;
                justify-content: space-between;
                align-items: center;
                margin: 10px;
                .items {
                  width: 100px;
                  height: 100%;

                  img {
                    display: block;
                    width: 70px;
                    height: 70px;
                  }
                }
                p {
                  font-size: 14px;
                  text-align: center;
                  max-width: 70px;
                }
                p:hover {
                  color: #0289f2;
                  cursor: pointer;
                }
              }
            }
            .dengdai {
              width: 100%;
              height: 420px;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              color: #bfbfbf;
              i {
                font-size: 80px;
              }
            }
          }
        }
        .cont-item:hover {
          background-color: #fff;
        }
        .cont-item:hover .infoBox {
          display: block;
        }
      }
      .cont-right {
        //margin-top: 1px;
        width: 15%;
        //height: 330px;
        /*background-color: #f5f5f5;*/
        .right-top {
          width: 100%;
          height: 150px;
          padding-top: 10px;
          background-color: #f5f5f5;
          .headDiv {
            img {
              display: block;
              margin: 0 auto;
            }
          }
          .login {
            text-align: center;
            color: #888;
            font-size: 12px;
            margin-top: 5px;
            .login-sure {
              display: flex;
              justify-content: space-around;
              span {
                cursor: pointer;
              }
            }
            .login-no {
              div {
                display: inline-block;
                font-size: 17px;
                padding: 0 5px;
              }
              span {
                color: orangered;
                font-size: 17px;
                font-weight: bold;
              }
              span:hover {
                color: #0289f2;
                cursor: pointer;
              }
            }
          }
        }
        .right-bottom {
          padding: 10px 0;
          background-color: #f7fbff;
         // height: 404px;
          font-size: 12px;
          text-align: center;
          color: #888;
          p {
            color: #0289f2;
          }
          ul {
            li {
              line-height: 24px;
            }
          }
        }
      }
    }
  }
  .popularSec {
    margin-top: 5px;
    width: 100%;
    // height: 220px;
    color: #fff;
    //background-color: #fafafa;
    a, a:link, a:visited, a:hover, a:active {
      text-decoration: none;
    }

    a {
      color: #666;
    }
    .black {
      color: #000000 !important;
    }
    h1, h2, h3, h4, h5, h6 {
      font-weight: normal;
      font-size: 100%;
    }
    .baojia{ width:1515px; margin:10px auto 5px; font-family:"微软雅黑"; position:relative;  min-width:1515px;}
    .baojia ul li{ width:290px; height:120px; float:left; display:inline-block; margin-right:8px; border:1px solid #d4d4d4; margin-top:10px;     border-radius: 8px;
    }
    .baojia ul li:hover{ border:1px solid #47a7fe;}
    .baojia ul li a:hover{ border:1px solid #47a7fe;}
    .baojia ul  .bg66_1{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_1:hover{ border:1px solid #ff772b;}
    .baojia ul  .bg66_2{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_2:hover{ border:1px solid #fb6d85;}
    .baojia ul  .bg66_3{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_3:hover{ border:1px solid #876cd5;}

    .baojia ul  .bg66_4{ background:url() no-repeat 41px 27px; margin-right:0px;}
    .baojia ul  .bg66_4:hover{ border:1px solid #47a7fe;}

    .baojia ul  .bg66_5{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_5:hover{ border:1px solid #9ec641;}

    .baojia ul  .bg66_6{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_6:hover{ border:1px solid #efb925;}

    .baojia ul  .bg66_7{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_7:hover{ border:1px solid #f33855;}

    .baojia ul  .bg66_8{ background:url() no-repeat 41px 27px;margin-right:0px;}
    .baojia ul  .bg66_8:hover{ border:1px solid #57baa6;}

    .baojia ul  .bg66_9{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_9:hover{ border:1px solid #d730fc;}

    .baojia ul  .bg66_10{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_10:hover{ border:1px solid #22be2d;}

    .baojia ul  .bg66_11{ background:url() no-repeat 41px 27px;}
    .baojia ul  .bg66_11:hover{ border:1px solid #545e55;}

    .baojia ul  .bg66_12{ background:url() no-repeat 41px 27px;margin-right:0px;}
    .baojia ul  .bg66_12:hover{ border:1px solid #c32526;}
    .mr0{margin-right:0px;}
    .baojia ul li h3{ font-size:18px; margin-top:50px; margin-left:115px; }
    .baojia ul li p{ font-size:13px; color:#666; margin-left:110px; width:120px; white-space:nowrap;overflow:hidden;text-overflow:ellipsis; }

    .ban {
      width: 80%;
      // height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .dv1 {
        width: 210px;
        padding-top: 40px;
        background-color: #6bbbf9;
        text-align: center;
        .p1 {
          font-size: 20px;
          line-height: 24px;
        }
        .p2 {
          font-size: 26px;
          line-height: 56px;
        }
        .p3 {
          padding: 0 2px;
          color: #0289f2;
          font-size: 14px;
          line-height: 28px;
          background-color: #fff;
        }
        .p4 {
          font-size: 16px;
          line-height: 56px;
        }
      }
      .dv2 {
        width: 330px;
        border-top: 3px solid #ff9600;
        background-color: #ffd59a;
      }
      .dv2:nth-child(2) {
        width: 330px;
        border-top: 3px solid #ed4d49;
        background-color: #e9d4c1;
      }
      .dv2:last-child {
        width: 330px;
        border-top: 3px solid #10c55b;
        background-color: #def9dc;
      }
      /*.dv3 {*/
      /*  width: 330px;*/
      /*  border-top: 3px solid #ed4d49;*/
      /*  background-color: #e9d4c1;*/
      /*}*/
      /*.dv4 {*/
      /*  width: 330px;*/
      /*  border-top: 3px solid #10c55b;*/
      /*  background-color: #def9dc;*/
      /*}*/
      .infoDiv {
        float: left;
        width: 154px;
        height: 180px;
        background: url("../../static/imgs/bg_orange_popular.png") no-repeat
          center;
        margin-left: 30px;
        text-align: center;
        width: calc(100% - 60px);
        background-size: 100% 100%;
        .p1 {
          padding-top: 25px;
          font-size: 22px;
          line-height: 32px;
        }
        span {
          display: block;
          width: 50px;
          margin: 0 auto;
          border: none;
          border-bottom: 2px solid #fff;
        }
        .p2 {
          font-size: 14px;
          line-height: 34px;
          margin-bottom: 8px;
        }
        .p3 {
          i {
            display: block;
            width: 30px;
            height: 30px;
            margin: 0 auto;
            background: url("../../static/imgs/icon_link_hot.png") no-repeat
              center;
            background-size: cover;
          }
          p {
            margin-top: 6px;
            font-size: 14px;
            line-height: 14px;
            text-align: center;
          }
        }
        .p3:hover {
          cursor: pointer;
          text-decoration: underline;
        }
      }
      .imgDiv {
        float: left;
        margin: 40px 0 0 5px;
        img {
          width: 120px;
          height: 140px;
        }
      }
      .dv2:nth-child(2) .infoDiv {
        background: url("../../static/imgs/bg_red_popular.png") no-repeat center;
        width: calc(100% - 60px);
        background-size: 100% 100%;
      }
      .dv2:last-child .infoDiv {
        background: url("../../static/imgs/bg_green_popular.png") no-repeat
          center;
        width: calc(100% - 60px);
        background-size: 100% 100%;
      }
    }
  }
  // .infoSec {
  //   width: 100%;
  //   background-color: #fafafa;
  //   .ban {
  //     width: 1200px;
  //     margin: 0 auto;
  //     .infoDiv {
  //       width: 100%;
  //       display: flex;
  //       justify-content: space-between;
  //       flex-wrap: wrap;
  //       .dv1,
  //       .dv2,
  //       .dv3 {
  //         box-sizing: border-box;
  //         position: relative;
  //         width: 374px;
  //         height: 227px;
  //         padding: 42px 30px 0;
  //         border: 1px solid #d9d9d9;
  //         background-color: #fff;
  //         box-shadow: 0 0 5px 2px rgb(0 0 0 / 15%);
  //         .topic {
  //           position: absolute;
  //           span {
  //             position: absolute;
  //             left: -14px;
  //             top: -12px;
  //             font-family: Arial;
  //             font-size: 40px;
  //             font-weight: bold;
  //             color: rgba(48, 192, 246, 0.23);
  //           }
  //           p {
  //             width: 320px;
  //             font-size: 18px;
  //             line-height: 42px;
  //             color: #4c4c4c;
  //             white-space: nowrap;
  //             overflow: hidden;
  //             text-overflow: ellipsis;
  //           }
  //           hr {
  //             position: absolute;
  //             bottom: 0;
  //             left: 0;
  //             width: 68px;
  //             border: none;
  //             border-bottom: 2px solid #0289f2;
  //           }
  //         }
  //         .info {
  //           white-space: wrap;
  //           overflow: hidden;
  //           text-overflow: ellipsis;
  //           margin-top: 60px;
  //           font-size: 14px;
  //           line-height: 24px;
  //           color: #999;
  //         }
  //       }
  //     }
  //   }
  // }
  .noticeSec {
    width: 100%;
    //background-color: #fafafa;
    .ban {
      width: 1500px;
      margin: 0 auto;
      .header {
        .moreNotice {
          cursor: pointer;
        }
      }
      .noticeDiv {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .dv1 {
          box-sizing: border-box;
          position: relative;
          width: 374px;
          height: 338px;
          border: 1px solid #d9d9d9;
          background-color: #fff;
          box-shadow: 0 0 5px 2px rgb(0 0 0 / 15%);
          .imgDiv {
            position: relative;
            width: 100%;
            height: 218px;
            img {
              display: block;
              width: 100%;
              max-height: 218px;
            }
          }
          .muns {
            position: absolute;
            left: 19px;
            bottom: -16px;
            width: 72px;
            height: 72px;
            padding-top: 10px;
            background-color: #0289f2;
            color: #fff;
            text-align: center;
            p:first-child {
              font-size: 32px;
              font-weight: bold;
            }
            p:last-child {
              font-size: 14px;
            }
          }
          .contentDiv {
            padding: 22px 19px 0;
            .topic {
              width: 338px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 18px;
              line-height: 40px;
              color: #4c4c4c;
            }
            p {
              max-height: 75px;
              font-size: 14px;
              line-height: 24px;
              color: #999;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          hr {
            position: absolute;
            bottom: 15px;
            right: 18px;
            width: 48px;
            border: none;
            border-bottom: 2px solid #0289f2;
          }
        }
        .last {
          .dv1 {
            height: 0;
            box-shadow: none;
            border: none;
          }
        }
      }

      .noticeDiv-two {
        text-align: center;
        font-size: 24px;
        padding: 20px 0;
      }
    }
  }
  .orderSec {
    width: 100%;
    background-color: #fafafa;
    padding-bottom: 40px;
    border-bottom: 1px solid #809090;


    .ban {
      width: 1500px;
      margin: 0 auto;
      .orderInfoDiv {
        width: 1500px;
        margin: 0 auto;
        height: 344px;
        overflow: hidden;
        .swiper {
          width: 100%;
          height: 100%;
          .swiper-slide {
            width: 100%;
            height: 100%;
          }
        }
        .order {
          width: 100%;
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          li {
            width: 560px;
            height: 172px;
            background: url("../../static/imgs/img_orderInfoBox.png") no-repeat
              bottom;
            .info {
              box-sizing: border-box;
              display: table;
              height: 130px;
              padding: 20px 26px;
              display: flex;
              .imgDiv {
                display: table-cell;
                width: 90px;
                height: 90px;
                vertical-align: middle;
                /*background-color: #f1f1f1;*/
                img {
                  display: block;
                  height: 90%;
                  margin: auto;
                  width: 81px;
                  height: 81px;
                }
              }
              .contentDiv {
                width: 420px;
                padding: 10px 0 10px 18px;
                display: table-cell;
                vertical-align: top;
                p {
                  font-size: 16px;
                  color: #999;
                  line-height: 25px;
                }
              }
            }
          }
        }
        .bottom {
          text-align: center;
          font-size: 24px;
          padding: 20px 0;
        }
      }
      .orderProcessDiv {
        display: flex;
        align-items: center;
        width: 100%;
        height: 140px;
        margin-top: 8px;
        background-color: #fff;
        border-top: 1px solid #0289f2;
        border-bottom: 8px solid #0289f2;
        .desc {
          font-size: 24px;
          color: #0289f2;
          line-height: 132px;
          padding: 0 28px;
        }
        ul {
          display: table-cell;
          li {
            position: relative;
            display: inline-block;
            vertical-align: middle;
            span {
              display: block;
              margin: 0 auto;
              width: 44px;
              height: 44px;
              font-size: 20px;
              line-height: 44px;
              color: #0289f2;
              text-align: center;
              background: url("../../static/imgs/bg_circle.png") no-repeat
                center;
              background-size: cover;
            }
            p {
              margin-top: 20px;
              font-size: 18px;
              color: #777;
              text-align: center;
            }
          }
          li:not(:first-child) {
            margin-left: 58px;
          }
          li:not(:first-child):before {
            position: absolute;
            display: block;
            width: 28px;
            height: 12px;
            top: -50px;
            bottom: 0;
            left: -43px;
            margin: auto 0;
            content: url("../../static/imgs/icon_arrow_process.png");
          }
        }
      }
    }
  }
  // 公共头部信息
  .header {
    position: relative;
    padding: 20px 0 40px 0;
    text-align: center;
    .p1 {
      font-size: 26px;
      line-height: 36px;
      color: #4c4c4c;
      font-weight: bold;
    }
    .p2 {
      font-size: 24px;
      line-height: 34px;
      color: #4c4c4c;
    }
    hr {
      margin: 5px auto 0;
      width: 68px;
      border: none;
      border-bottom: 2px solid #0289f2;
    }
    span {
      height: 16px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      margin: auto 0;
      font-size: 14px;
      line-height: 16px;
      color: #4c4c4c;
    }
  }
}
</style>
